import { el, setChildren, list } from 'redom';

import SecondLevelCTA from 'generics/components/second-level-cta';

import reminderUnits from 'constants/reminder-units';

import ReminderInput from './reminder-input';

import './index.scss';

class RemindersInput {

  constructor(configuration) {

    this.initialReminders = structuredClone(configuration.reminders);
    this.reminders = structuredClone(configuration.reminders);
    this.onUpdate = configuration.onUpdate || function noop() {};
    this.onAdd = configuration.onAdd || function noop(reminder) {
      reminder._id = '' + Date.now();
      return reminder;
    };
    this.onRemove = configuration.onRemove || function noop() {};
    this.onChange = configuration.onChange || function noop() {};

    this.reminderInputs = list('#reminders-input-list', ReminderInput, null, this);
    this.addReminderButton = new SecondLevelCTA({
      label: 'Add Reminder',
      onClick: this.handleAddReminderClick.bind(this)
    });

    this.el = el('#reminders-input-main', [
      this.addReminderButton
    ]);

    this.updateReminderInputs();

  }

  handleChange(type, reminder) {

    const reminders = structuredClone(this.getValue());

    const modified = JSON.stringify(reminders) !== JSON.stringify(this.initialReminders);

    this.onChange({ value: reminders, modified, type, reminder });

  }

  async handleAddReminderClick() {

    const reminder = {
      unit: reminderUnits.MINUTES,
      value: 10
    };

    this.reminders.push(reminder);

    this.updateReminderInputs();

    this.addReminderButton.el.scrollIntoView();

    this.handleChange('added', reminder);

  }

  removeReminder(index) {

    const reminder = this.reminders[index];

    this.reminders.splice(index, 1);

    this.updateReminderInputs();

    this.onRemove(reminder);

    this.handleChange('deleted', reminder);

  }

  handleReminderChange(reminder, index) {

    this.reminders[index] = reminder;

    this.onUpdate(reminder);

    this.handleChange('updated', reminder);

  }

  updateReminderInputs() {

    this.reminderInputs.update(this.reminders);

    if (this.reminders.length > 0) {
      setChildren(this.el, [this.reminderInputs, this.addReminderButton]);
    } else if (this.reminders.length === 0) {
      setChildren(this.el, [this.addReminderButton]);
    }

  }

  getValue() {

    return this.reminders;

  }

  setValue(reminders) {

    this.reminders = reminders;

    this.updateReminderInputs();

  }

}

export default RemindersInput;